import { Modal, Alert, Typography } from 'antd';
import { AccountingDisclaimer } from './shared/AccountingDisclaimer';
import { useGenerateReportPack } from './hooks/useGenerateReportPack';
import { fmtCents } from './shared/formatCents';

export function GenerateReportPackModal({
  customerId,
  year,
  open,
  onClose,
  uncategorizedCount = 0,
  uncategorizedTotalCents = 0,
}: {
  customerId: string;
  year: number;
  open: boolean;
  onClose: () => void;
  uncategorizedCount?: number;
  uncategorizedTotalCents?: number;
}) {
  const generate = useGenerateReportPack();

  return (
    <Modal
      open={open}
      title={`Generate ${year} Accounting Report`}
      onCancel={onClose}
      centered
      okText="Generate"
      okButtonProps={{ loading: generate.isPending }}
      onOk={async () => {
        await generate.mutateAsync({ customerId, report_year: year });
        onClose();
      }}
    >
      <Typography.Paragraph>
        This will generate a downloadable bundle for {year} containing your
        income statement, top payers, top vendors, and full transaction
        register. We'll email you when it's ready.
      </Typography.Paragraph>

      {uncategorizedCount > 0 && (
        <Alert
          type="warning"
          showIcon
          style={{ marginBottom: 12 }}
          message={`${uncategorizedCount} transactions (${fmtCents(uncategorizedTotalCents)}) are uncategorized — they'll appear in an "Uncategorized" bucket on the report.`}
        />
      )}

      <AccountingDisclaimer />
    </Modal>
  );
}
